module.exports = __webpack_public_path__ + "img/ic_24_logo.7200cbe2.svg";